export const CHECK_TOKEN = "CHECK_TOKEN";

export const GET_PROFILE = "GET_PROFILE";

export const GET_FAQ = "GET_FAQ";

export const GET_NEWS = "GET_NEWS";

export const UPDATE_USER = "UPDATE_USER";
